import { Component } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { MeetingService } from '../../services/meeting.service';
import { ToasterService} from 'angular2-toaster';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

declare var document: any;
declare var $: any;

@Component({
  selector: 'app-makepayment',
  templateUrl: './makepayment.component.html',
  styleUrls: ['./makepayment.component.css']
})
export class MakepaymentComponent {

  busy: Promise<any>;
  user: any = [];
  authcode: any;
  avail_hours: any;
  total_qty = 0;
  total_qty2 = 0;
  total_qty3 = 0;
  final_qty = 0;
  total_price1 = 0;
  total_price2 = 0;
  total_price3 = 0;
  final_total = 0;
  qty_form: FormGroup;
  qty_form2: FormGroup;
  qty_form3: FormGroup;
  cardcvv: FormGroup;
  qty: any;
  submitAttempt: boolean;
  qty1: any;
  qty2: any;
  qty3: any;
  cvv: any;
  interval: any;
  cs_msg: any;
  err_msg: any;
  saved_cards: any = [];
  // err_msg: any;

  constructor(
    private storage: LocalStorageService,
    public router: Router,
    private _cookieService: CookieService,
    public formBuilder: FormBuilder,
    public meetingService: MeetingService,
    private toasterService: ToasterService) {

        const val = this.storage.get('user');
        if (val) {
          this.user = val;
          // console.log(this.user);
          this.authcode = val[0].authcode;
        } else {
          const link = ['/login'];
          this.router.navigate(link);
        }

        this.qty_form = formBuilder.group({
            qty1: ['', Validators.compose([Validators.maxLength(1), Validators.pattern('[1-4]')])],
        });
        this.cardcvv = formBuilder.group({
            cvv: ['', Validators.compose([Validators.maxLength(4), Validators.pattern('[0-9 ]*'), Validators.required])],
        });

        if (this.storage.get('open_from_addhours') && this.storage.get('open_from_addhours') === 'yes') {
          // console.log('yes');
          this.storage.remove('open_from_addhours');
        }

        this.getavailHours();

  }

  getavailHours() {
    this.meetingService.getavailHours(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        // console.log(response);
        this.avail_hours = response.hours;
        this.user[0].hours = this.avail_hours;
        this.storage.set('user', this.user);
        this.GetSavedCards();
      }
      } else {
        // console.log("error");
      }
    }, (err) => {
      this.signOut();
    });
  }

  checkAmax() {
    $('#check_err').empty();
    const selected_card = $('input[name="scard"]:checked').val();
    for (let c = 0; c < this.saved_cards.length; c++) {
      if (this.saved_cards[c].cardid === selected_card) {
        if (this.saved_cards[c].cardtype === 'AMEX') {
          $('#amaxnotice').html('Enter 4 digit security code from the front of your card');
        } else {
          $('#amaxnotice').html('Enter 3 digit security code from the back of your card');
        }
      }
    }
  }

  isFormControlDirty(form: FormGroup, controlName: string): boolean {
    return form.get(controlName).dirty;
  }

  checkaggr() {
    $('#agg_err').empty();
  }

  goToProfile() {
    const link = ['/profile'];
    this.router.navigate(link);
  }


  addHours(id) {
    // console.log(id);
    this.meetingService.GetSavedCards(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        if (response === '') {
          if (this.storage.get('select_city_id')) {
            const cid = this.storage.get('select_city_id');
            window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=' + cid, '_blank');
          } else {
            window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=0', '_blank');
          }
          // console.log("no saved card found");
        } else {
          this.storage.set('open_from_addhours', 'yes');
          setTimeout(function() {
              (<any>$('#myModal')).modal('show');
          }, 500);

        }
      }
      } else {
        // console.log("error");
      }
    });
  }

  addhoursqry(id) {
    // // console.log(id);
    // this.eventremember();
    const hour = document.getElementById('miss_hour').value;
    // // console.log(hour);

    const cid = this.storage.get('select_city_id') ? this.storage.get('select_city_id') : '0';

    if (hour === 5) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price2=1&city=' + cid, '_blank');
    } else if (hour === 15) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price3=1&city=' + cid, '_blank');
    } else {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price1=' + hour + '&city=' + cid, '_blank');
    }

  }

  openSelf() {
    const link = ['/makepayment'];
    this.router.navigate(link);
  }

  payforhour() {
    this.submitAttempt = true;
    if (!$('.radiobtn').is(':checked')) {
      $('#check_err').html('Please select one card');
    } else {
      $('#check_err').empty();
    }
    if (!$('.aggriment').is(':checked')) {
      $('#agg_err').html('Please check aggriment');
    } else {
      $('#agg_err').empty();
    }
    if (this.qty1) {
      this.total_qty = this.qty1;
    } else {
      this.total_qty = 0;
    }if (this.qty2) {
      this.total_qty2 = 5 * this.qty2;
    } else {
      this.total_qty2 = 0;
    }if (this.qty3) {
      this.total_qty3 = 15 * this.qty3;
    } else {
      this.total_qty3 = 0;
    }
    this.final_qty = this.total_qty + this.total_qty2 + this.total_qty3;
    if (this.final_qty === 0) {
      $('#hour_qty_err').html('Please enter hours in atleast one textbox');
    } else {
      $('#hour_qty_err').empty();
    }

    if (!this.qty_form.valid) {
        // console.log("not valid");
    } else if (!this.cardcvv.valid) {

    } else {


      this.makePayment();
      // this.useSavedCard();
    }
  }

  GetSavedCards() {

    this.meetingService.GetSavedCards(this.authcode).subscribe(response => {
      // console.log('SavedCards');
      // console.log({response});
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        if (response === '') {

        } else {
          this.saved_cards = response;
          // console.log(this.saved_cards);
        }
      }
      }
    });
  }

  openSavedCard() {
    const link = ['/savedcard'];
    this.router.navigate(link);
  }

  makePayment() {
    if (this.final_qty === 0) {
      $('#hour_qty_err').html('Please enter hours in atleast one textbox');
    } else {
    const cardid = $('input[name="scard"]:checked').val();
    if ($('.radiobtn').is(':checked') && $('.aggriment').is(':checked')) {
      this.busy = this.meetingService.useSavedCard(this.authcode, this.user[0].userid, this.final_total, cardid, this.cvv, this.final_qty)
      .subscribe(response => {
        if (response) {
          if (+ response.success === -1) {
            this.logOut(response.message);
          } else {
          if (response.success === 1) {
            this.cs_msg = response.message;
            window.scrollTo(0, 0);
          } else {
            $('#update_add').show();
            this.err_msg = response.message;
            window.scrollTo(0, 0);
            this.interval = setTimeout(() => {
              this.err_msg = '';
            }, 4000);
          }
        }
        } else {
          // console.log("error");
        }
      });
    }
    }
  }

  checkTotal() {
    $('#hour_qty_err').empty();
    // this.total_price = (25 * this.qty1)+(100 * this.qty2)+()
    if (this.qty1) {
      this.total_price1 = 25 * this.qty1;
    } else {
      this.total_price1 = 0;
    }if (this.qty2) {
      this.total_price2 = 100 * this.qty2;
    } else {
      this.total_price2 = 0;
    }if (this.qty3) {
      this.total_price3 = 225 * this.qty3;
    } else {
      this.total_price3 = 0;
    }
    this.final_total = this.total_price1 + this.total_price2 + this.total_price3;

  }

  signOut() {
    this.busy = this.meetingService.logout(this.authcode).subscribe(response => {
      if (response) {
        if (response[0].success === 1) {
          // console.log(response);
          this.storage.remove('user');
          this.storage.remove('select_city');
          this.storage.remove('select_city_id');
          this.storage.remove('select_building');
          this.storage.remove('select_building_id');
          this.storage.remove('select_room');
          this.storage.remove('select_room_id');
          this.storage.remove('seats');
          this.authcode = null;
          this._cookieService.put('msg', response[0].message);
          const link = ['/login'];
          this.router.navigate(link);
          // this.delete_cookie('user');
          // window.location.href = "http://ovo.dev.bluelightit.com/?message=Logout%20Successful";
        } else {
          this.toasterService.pop('error', response[0].message);
        }
      } else {
        // console.log("error");
      }
    }, (err) => {
      this.signOut();
    });
    // let link = ['/login'];
    // this.router.navigate(link);
  }

  logOut(message) {
    this.storage.remove('user');
    this.storage.remove('select_city');
    this.storage.remove('select_city_id');
    this.storage.remove('select_building');
    this.storage.remove('select_building_id');
    this.storage.remove('select_room');
    this.storage.remove('select_room_id');
    this.storage.remove('seats');
    this.authcode = null;
    this._cookieService.put('msg', message);
    const link = ['/login'];
    this.router.navigate(link);
  }

}
